<div
  class="group relative inline-flex w-11 shrink-0 rounded-full bg-outline dark:bg-outline-darkmode p-0.5 inset-ring inset-ring-outline/5 dark:inset-ring-outline-darkmode/5 outline-offset-2 outline-primary dark:outline-primary-darkmode transition-colors duration-200 ease-in-out has-checked:bg-primary dark:has-checked:bg-primary-darkmode has-focus-visible:outline-2"
>
  <span
    class="relative size-5 rounded-full bg-surface shadow-xs ring-1 ring-gray-900/5 transition-transform duration-200 ease-in-out group-has-checked:translate-x-5"
  >
    <span
      aria-hidden="true"
      class="text-on-surface absolute inset-0 flex size-full items-center justify-center opacity-100 transition-opacity duration-200 ease-in group-has-checked:opacity-0 group-has-checked:duration-100 group-has-checked:ease-out"
    >
      <ng-content select="[slot=icon-off]" />
    </span>
    <span
      aria-hidden="true"
      class="text-on-surface absolute inset-0 flex size-full items-center justify-center opacity-0 transition-opacity duration-100 ease-out group-has-checked:opacity-100 group-has-checked:duration-200 group-has-checked:ease-in"
    >
      <ng-content select="[slot=icon-on]" />
    </span>
  </span>
  <input
    [attr.id]="inputId()"
    type="checkbox"
    class="cursor-pointer absolute inset-0 size-full appearance-none focus:outline-hidden"
    [checked]="checked()"
    (change)="onToggle($event.target.checked)"
    [disabled]="disabled()"
  />
</div>
